import { captureAcquisitionVisit } from '~/utils/orderAcquisition'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const shopSlug = useShopSlug()

  const capture = () => {
    if (!import.meta.client) return
    captureAcquisitionVisit({
      shopSlug: shopSlug.value,
      pathname: window.location.pathname,
      search: window.location.search,
      referrer: document.referrer || '',
      siteHost: window.location.host,
    })
  }

  capture()
  router.afterEach(() => {
    nextTick(capture)
  })
})
